import React, { useEffect } from "react"
import PropTypes from "prop-types"

// Utils
import { removefromDataLayer } from "components/Stacker/utils/DataLayer"

// Actions
import { clearQuickViewProduct } from "components/Stacker/actions/ProductDetailActions"

//	Configs
import ModalConfig from "components/Stacker/config/ModalConfig"

// Constants
import TC from "components/Stacker/constants/TrackingConstants"

// Components
import ModalGeneric from "components/Stacker/components/ModalGeneric/ModalGeneric"
import LoadingProductDetailsPage from "components/Stacker/components/ProductDetailsPage/LoadingProductDetailsPage"

import "./QuickViewModal.scss"
import { useDispatch } from "react-redux"

function QuickViewModal(props) {
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      handleClearQuickViewProduct()
    }
  }, [])

  const handleClearQuickViewProduct = () => {
    dispatch(clearQuickViewProduct())
    removefromDataLayer(TC.LAYER_QUICK_VIEW)
  }

  // TODO: remove this
  const loadProductDetails = () => {
    console.log("modal open")
  }

  return (
    <ModalGeneric
      name={ModalConfig.MODAL_QUICK_VIEW}
      onAfterOpen={loadProductDetails}
      handleClose={handleClearQuickViewProduct}
    >
      <LoadingProductDetailsPage isQuickView />
    </ModalGeneric>
  )
}

export default QuickViewModal
